import { Paper } from '@material-ui/core';
import { PaperProps } from '@material-ui/core/Paper';
import { ComponentType } from 'react';
import styled from 'styled-components';
import { Typography } from 'src/components/atoms';

export const UrgentOrderIndicatorContainer: ComponentType<PaperProps> = styled(Paper)`
  && {
    box-sizing: border-box;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
    border-radius: 2px;
    background-color: ${props => props.theme.palette.expressDelivery.header};
  }
`;

export const UrgentHeaderRow = styled.div`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

export const UrgentText = styled(Typography)`
  && {
    color: ${props => props.theme.palette.background};
    font-size: 18px;
    font-weight: bold;
  }
`;

export const DateText = styled(Typography)`
  && {
    color: ${props => props.theme.palette.background};
    font-weight: bold;
    margin-top: 16px;
    align-self: flex-start;
  }
`;

export const PeriodName = styled(Typography)`
  && {
    margin-top: 18px;
    font-weight: bold;
    color: ${props => props.theme.palette.background};
  }
`;

export const Period = styled.div<{ $active: boolean }>`
  && {
    opacity: ${props => (props.$active ? 1 : 0.3)};
    margin-left: 12%;
    margin-right: 12%;
    width: 40px;
    height: 80px;
    filter: brightness(0) invert(1);
  }
`;

export const PeriodsRow = styled.div`
  && {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    margin-top: 16px;
  }
`;
